// src/pages/FeatureDisabledPage.jsx

import { PageHeader } from '../components/PageHeader';
import { ShieldOff } from 'lucide-react';
import logoPrincipal from '../assets/logo-principal.png';

export default function FeatureDisabledPage() {
  return (
    <>
      <PageHeader title="Acesso Negado" />
      {/* 1. Alterado o fundo do container para azul claro */}
      <div className="flex flex-col items-center justify-center text-center p-8 rounded-lg bg-blue-50 dark:bg-blue-900/20">
        
        <div className="relative w-32 h-32 flex items-center justify-center">
          {/* A opacidade do logo pode ser um pouco maior agora para combinar com o azul */}
          <img 
            src={logoPrincipal} 
            alt="Logo O Porteiro" 
            className="w-full h-full object-contain opacity-60" 
          />
          
          {/* 2. Alterado o filtro de sobreposição e a cor do ícone para azul */}
          <div className="absolute inset-0 flex items-center justify-center rounded-full bg-blue-500/20">
            <ShieldOff className="h-16 w-16 text-blue-600 dark:text-blue-400" />
          </div>
        </div>

        {/* 3. Alterada a cor do texto do título para azul */}
        <h2 className="mt-6 text-2xl font-bold text-blue-800 dark:text-blue-200">
          Funcionalidade Indisponível
        </h2>
        <p className="mt-2 max-w-md text-gray-600 dark:text-gray-400">
          Esta funcionalidade não está disponível para sua licença. Por favor, entre em contato com a administração para mais informações.
        </p>
      </div>
    </>
  );
}
